import process from 'node:process';
import { unsupportedNodeRuntimeMessage } from './runtime.js';

const runtimeError = unsupportedNodeRuntimeMessage(process.versions.node);
if (runtimeError) {
  console.error(runtimeError);
  process.exitCode = 1;
} else {
  void import('./index.js').then(({ main }) => main(process.argv.slice(2)));
}
